import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createVNode as _createVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3ec6100a")

_pushScopeId("data-v-3ec6100a")
const _hoisted_1 = { class: "flex-3 t-left df-middle" }
const _hoisted_2 = { class: "f-bold c-text mr-4" }
const _hoisted_3 = { class: "diff c-text mx-4" }
const _hoisted_4 = { class: "flex-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RealTimeQuote = _resolveComponent("RealTimeQuote")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_component_router_link, {
    to: `/symbol/${_ctx.code || _ctx.symbol && _ctx.symbol.code}`,
    custom: ""
  }, {
    default: _withId(({navigate}) => [
      _createVNode(_component_RealTimeQuote, { symbol: _ctx.symbol }, {
        default: _withId((synced) => [
          _createVNode("div", _mergeProps({
            class: [{'c-danger': !synced.isRise}, "bar df-middle c-success t-center"]
          }, _ctx.$attrs, { onClick: navigate }), [
            _renderSlot(_ctx.$slots, "default", synced, () => [
              _createVNode("div", _hoisted_1, [
                _createVNode("span", _hoisted_2, _toDisplayString(synced.code), 1),
                _createVNode("span", null, _toDisplayString(synced.price), 1),
                _createVNode("span", _hoisted_3, _toDisplayString(synced.spread), 1),
                _createVNode("span", null, _toDisplayString(synced.buy), 1)
              ]),
              _createVNode("div", _hoisted_4, _toDisplayString(synced.margin), 1),
              _createVNode("div", null, _toDisplayString(synced.mp), 1)
            ], true)
          ], 16, ["onClick"])
        ]),
        _: 2
      }, 1032, ["symbol"])
    ]),
    _: 1
  }, 8, ["to"]))
})